import { DateTime } from "luxon";

export const formateTransactionDate = (date: string) => {
  return DateTime.fromISO(date).toFormat("dd MMM yyyy hh:mm a");
};
